import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

const initGSAPTypewriter = () => {

	const typewriter = document.querySelector('.search-input-typewriter');
	const trigger = document.querySelector('.search-mag-glass');

	if (!typewriter) return;
	let split = SplitText.create(typewriter, { type: "words,chars" });
	gsap.set(split.chars, { autoAlpha: 0 });

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: typewriter,
			start: "top 80%",
			toggleActions: "play reset play reset",
		}
	});
	tl.to(split.chars, {
		autoAlpha: 1,
		duration: 0,
		stagger: 0.05,
		ease: "power1.out",
		smartWrap: true
	});

trigger && trigger.addEventListener('click', () => {
	tl.timeScale(5).reverse().then(() => tl.timeScale(1).then(() => tl.restart()));
});


}
export { initGSAPTypewriter };